"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinalNode = exports.verbNodes = exports.nomNodes = exports.detNodes = exports.pronomNodes = void 0;
////Pronons node 8/22
var tree_1 = require("../tree");
function toPNT(a, type) {
    function fName(pv, name) {
        if (pv[name]) {
            var n = parseInt(name.split("_").slice(-1)[0]);
            return isNaN(n) ?
                [name, "1"].join("_") :
                __spreadArrays(name.split("_").slice(0, -1), [n + 1]).join("_");
        }
        else
            return name;
    }
    return a.reduce(function (pv, p) {
        var n = fName.bind(null, pv);
        pv[n(p)] = new tree_1.TreeNode(p, { type: type });
        return pv;
    }, {});
}
function toArray(p) {
    return Object.keys(p).map(function (k) { return p[k]; });
}
////Pronoms nodes
exports.pronomNodes = toPNT(["je", "tu", "il", "elle", "on", "vous", "ils", "elles"], "pronom");
////Determinant nodes
exports.detNodes = toPNT([
    "le", "l'", "la", "les",
    "un", "une", "des",
    "ce", "cet", "cette", "ces"
], "determinant");
//// Nom Nodes
exports.nomNodes = toPNT([
    "voiture", "voitures", "herbe", "herbes",
    "camion", "camions", "animal", "animaux"
], "nom");
//// Verb Node
exports.verbNodes = toPNT([
    "manger", "mange", "manges", "mange", "mangeons", "mangez", "mangent",
], "verbe");
/// Error Node
function createErrNode(msg, correction) {
    return new tree_1.TreeNode(msg, { type: "error", correction: correction });
}
//// Final Nodes
exports.FinalNode = (_a = new tree_1.TreeNode()).AddParents.apply(_a, __spreadArrays(toArray(exports.pronomNodes), toArray(exports.detNodes), toArray(exports.nomNodes), toArray(exports.verbNodes)));
//// Node Linking
function linkPsTCsWithError(pNodes, cNodes, err, ps, cs) {
    ps.map(function (s) { return pNodes[s]; })
        .forEach(function (n) {
        if (err === null) {
            return n.AddChildren.apply(n, cs.map(function (s) { return cNodes[s]; }));
        }
        n.AddChildren(err.AddChildren.apply(err, cs.map(function (s) { return cNodes[s]; })));
    });
}
function linkNToDet(nom, masc, plu, voyelle) {
    var _a, _b, _c, _d;
    if (masc === void 0) { masc = false; }
    if (plu === void 0) { plu = false; }
    if (voyelle === void 0) { voyelle = false; }
    var linkErr = function (err, n, det) { return linkPsTCsWithError.call(null, exports.nomNodes, exports.detNodes, err, [n], det); };
    var link = linkErr.bind(null, null);
    var linkErrs = function (msg, nom, map) {
        Object.keys(map).forEach(function (corr) {
            linkErr(createErrNode(msg, corr), nom, map[corr]);
        });
    };
    if (plu) {
        link(nom, ["les", "des", "ces"]);
        linkErrs("un nom au pluriel doit avoir son determinant au pluriel", nom, {
            "les": ["le", "la", "l'"],
            "des": ["un", "une"],
            "ces": ["ce", "cet", "cette"],
        });
        return;
    }
    var det = masc ? __spreadArrays(["un"], (voyelle ? ["l'", "cet"] : ["le", "ce"])) :
        ["une", (voyelle ? "l'" : "la"), "cette"];
    link(nom, det);
    linkErrs(nom + " est singulier", nom, (_a = {},
        _a[det[0]] = ["des"],
        _a[det[1]] = ["les"],
        _a[det[2]] = ["ces"],
        _a)); // Err en Nombre
    linkErrs(nom + " est " + (masc ? "masculin" : "féminin"), nom, (_b = {},
        _b[det[0]] = [masc ? "une" : "un"],
        _b[det[1]] = [masc ? "la" : "le"],
        _b[det[2]] = __spreadArrays(masc ? ["cette"] : ["ce", "cet"]),
        _b)); // Err en genre
    linkErrs("placeHolder", nom, __assign((_c = {}, _c[det[1]] = [voyelle ? (masc ? "le" : "la") : "l'"], _c), masc ? (_d = {},
        _d[det[1]] = [voyelle ? "ce" : "cet"],
        _d) : {}));
}
function linkVerbeToNom(verb) {
    var noms = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        noms[_i - 1] = arguments[_i];
    }
    return linkPsTCsWithError(exports.verbNodes, exports.nomNodes, null, [verb], noms);
}
linkNToDet("voiture");
linkNToDet("voitures", false, true);
linkNToDet("herbe", false, false, true);
linkNToDet("herbes", false, true, true);
linkNToDet("camion", true);
linkNToDet("camions", true, true);
linkNToDet("animal", true, false, true);
linkNToDet("animaux", true, true, true);
linkVerbeToNom("mange_1", "voiture");
linkPsTCsWithError(exports.detNodes, exports.verbNodes, null, ["l'"], ["mange_1"]);
